import Immutable from "immutable";

export const createCommonConfig = (backendConfig, dashboardConfig) => {
  const inheritKeysArray = [
    "tagFilter",
    "clientFilter"
  ]
  const standardOverrides = backendConfig.get("standardOverrides");
  let timeframe = standardOverrides.get("timeframe");
  if (timeframe == null || timeframe.get("type") === "NONE") {
    timeframe = dashboardConfig.get("timeframe");
    inheritKeysArray.push("timeframe");
  }

  let qualifier = standardOverrides.get("qualifier");
  if (qualifier == null) {
    qualifier = dashboardConfig.get("qualifier");
    inheritKeysArray.push("qualifier");
  }

  return Immutable.Map()
      .set("title", backendConfig.get("title"))
      .set("timeframe", timeframe)
      .set("qualifier", qualifier)
      .set("clientFilter", dashboardConfig.get("clientFilter"))
      .set("tagFilter", dashboardConfig.get("tagFilter"))
      .set("entityToIds", dashboardConfig.get("entityToIds"))
      .set("inheritKeys", Immutable.List(inheritKeysArray));
};
